import { ScopesOfWork } from "../scopeOfWork";
import { TestEvents } from "../testEvents";

export function Tier2View() {
  return (
    <ul>
      <li className="mb-3">
        <ScopesOfWork filters={{ tier2: true }} />
      </li>
      <li className="mb-3">
        <TestEvents filters={{ tier2: true }} />
      </li>
    </ul>
  );
}
